import React from 'react';
import { Card, Tooltip } from 'antd';
import { useNavigate } from 'react-router-dom';

const PointsDisplay = ({ points = 0 }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    navigate("/agent-dashboard/points-detail");
  };

  return (
    <Tooltip placement="rightTop" title="Click to learn how points work">
      <Card
        hoverable
        onClick={handleClick}
        style={{ 
          width: 196,
          background: 'linear-gradient(to right, #4F46E5, #6366F1)',
          padding: '12px',
          borderRadius: '8px',
          border: 'none',
          cursor: 'pointer',
          height: '75%',
        }}
        bodyStyle={{ 
          padding: 0,
          height: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <div style={{ 
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'center',
          gap: '8px',
          width: '100%'
        }}>
          <span style={{ 
            color: 'rgba(255, 255, 255, 0.85)',
            fontSize: '14px',
            fontWeight: 500 
          }}>
            Available Points:
          </span>
          <span style={{ 
            color: 'white',
            fontSize: '20px',
            fontWeight: 600
          }}>
            {points?.toLocaleString() || 0}
          </span>
        </div>
      </Card>
    </Tooltip>
  );
};

export default PointsDisplay;